module.exports = __webpack_public_path__ + "static/media/coverteye-5.6d1f00dd.jpg";